import { render, staticRenderFns } from "./Electricity.vue?vue&type=template&id=ab350120&scoped=true&"
import script from "./Electricity.vue?vue&type=script&lang=ts&"
export * from "./Electricity.vue?vue&type=script&lang=ts&"
import style0 from "./Electricity.vue?vue&type=style&index=0&id=ab350120&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab350120",
  null
  
)

export default component.exports